module.exports = __webpack_public_path__ + "media/images/common/large_on-b23ff84d38e9b0cf59c1a0cd1fb7d489.gif";